import React, { Component } from "react";
import Field from "./Field";
import FormNav from "./FormNav";
import { Formik, Form } from "formik";
import _ from "lodash";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons'

class FormWrapper extends Component {
  createMarkup(content) {
    return { __html: content };
  }

  render() {
    let {
      appID,
      isApplicationOpen,
      application,
      history,
      logo,
      logout,
      match,
      pageErrors,
      name,
      nav,
      setDestination,
      slug,
      isSubmitted,
      subID,
      submitAndNavigate,
      user,
      // validationSchemas,
      ...props
    } = this.props;

    if (isSubmitted) {
      history.push(`/${slug}/review`);
    }

    let pageNum = parseInt(match.params.page, 10);

    let currentSchema = application.schemas[pageNum].schema;
    let currentUiSchema = application.schemas[pageNum].uiSchema;
    // let currentValidationSchema = validationSchemas[pageNum];
    let currentFields =
      currentUiSchema["ui:order"] || Object.keys(currentSchema.properties);

    let navProps = _.pick(this.props, [
      "appID",
      "isApplicationOpen",
      "application",
      "history",
      "logout",
      "match",
      "pageErrors",
      "setDestination",
      "isSubmitted",
      "subID",
      "user"
    ]);

    window.scrollTo(0, 0);
    return (
      <Formik
        enableReinitialize={true}
        initialValues={props.initialValues}
        onSubmit={values => {
          // we only want to submit values from the current page
          let pageValues = _.pick(values, currentFields);
          console.log(":: UPDATING FORM VALUES ON SUBMIT", values, currentFields);
          submitAndNavigate(pageValues);
        }}
        appID={appID}
        render={formProps => {
          return (
            <Form noValidate="novalidate">
              <button type="submit" className="d-none">
                Save
              </button>
              <div className="row">
                <FormNav orientation="vertical" {...navProps} />
                <div className="col py-4">
                  <h2
                    id="form-title"
                    tabIndex="-1"
                    style={{
                      display: "title" in currentSchema ? "block" : "none"
                    }}
                  >
                    {currentSchema.title || "Form"}
                  </h2>
                  {"description" in currentSchema && (
                    <p
                      dangerouslySetInnerHTML={this.createMarkup(
                        currentSchema.description
                      )}
                    />
                  )}
                  {currentFields.map(id => {
                    return (
                      <Field
                        appID={appID}
                        errors={formProps.errors}
                        handleChange={formProps.handleChange}
                        handleBlur={formProps.handleBlur}
                        key={id}
                        id={id}
                        required={currentSchema.required.indexOf(id) > -1}
                        schema={currentSchema.properties[id]}
                        setFieldValue={formProps.setFieldValue}
                        subID={subID}
                        uiSchema={currentUiSchema[id]}
                        value={formProps.values[id]}
                        values={formProps.values}
                      />
                    );
                  })}
                  <button
                    className="btn btn-secondary nav-btn"
                    disabled={!formProps.dirty}
                    type="submit"
                  >
                    <FontAwesomeIcon
                      icon={
                        formProps.dirty ? faExclamationCircle : faCheckCircle
                      }
                    />{" "}
                    Save
                  </button>
                  <FormNav orientation="simple" {...navProps} />
                </div>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/FormWrapper.js